import { useTranslation, Trans } from 'next-i18next'
import useConfig from 'modules/config/state/use-config'
import { GFM_PRO_PRIVACY_POLICY_URL, GFM_PRO_TERMS_URL } from 'utils/constants/misc'

export const PrivacyPolicyNotice = () => {
  const { i18n } = useTranslation()
  const config = useConfig()
  const organization = config.organization || {}

  const privacyPolicyURL = organization.privacy_policy_url || organization.url || null
  const hasOrgPrivacyPolicy = !!privacyPolicyURL
  const language = i18n.language

  return (
    <>
      {hasOrgPrivacyPolicy ? (
        <>
          <Trans i18nKey="DonorInformationStep.TermsPrivacy.orgPrivacyPolicyUrl">
            We partner with GoFundMe to power this page. By donating, you agree to our{' '}
            <a
              href={privacyPolicyURL}
              target="_blank"
              data-id="org-privacy-link"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>{' '}
            along with GoFundMe&apos;s{' '}
            <a
              href={
                GFM_PRO_TERMS_URL[language as keyof typeof GFM_PRO_TERMS_URL] ||
                GFM_PRO_TERMS_URL.default
              }
              target="_blank"
              data-id="classy-terms-link"
              rel="noopener noreferrer"
            >
              Terms
            </a>{' '}
            and GoFundMe{' '}
            <a
              href={
                GFM_PRO_PRIVACY_POLICY_URL[language as keyof typeof GFM_PRO_PRIVACY_POLICY_URL] ||
                GFM_PRO_PRIVACY_POLICY_URL.default
              }
              target="_blank"
              data-id="classy-privacy-link"
              rel="noopener noreferrer"
            >
              Privacy Notice
            </a>
            .
          </Trans>
        </>
      ) : (
        <Trans i18nKey="DonorInformationStep.TermsPrivacy.default">
          We partner with GoFundMe to power this page. By donating, you agree to GoFundMe&apos;s{' '}
          <a
            href={
              GFM_PRO_TERMS_URL[language as keyof typeof GFM_PRO_TERMS_URL] ||
              GFM_PRO_TERMS_URL.default
            }
            target="_blank"
            data-id="classy-terms-link"
            rel="noopener noreferrer"
          >
            Terms
          </a>{' '}
          and{' '}
          <a
            href={
              GFM_PRO_PRIVACY_POLICY_URL[language as keyof typeof GFM_PRO_PRIVACY_POLICY_URL] ||
              GFM_PRO_PRIVACY_POLICY_URL.default
            }
            target="_blank"
            data-id="classy-privacy-link"
            rel="noopener noreferrer"
          >
            Privacy Notice
          </a>
          .
        </Trans>
      )}
    </>
  )
}
